import { render, staticRenderFns } from "./B2bAssessmentQuestion.vue?vue&type=template&id=3995a3be&scoped=true"
import script from "./B2bAssessmentQuestion.vue?vue&type=script&lang=js"
export * from "./B2bAssessmentQuestion.vue?vue&type=script&lang=js"
import style0 from "./B2bAssessmentQuestion.vue?vue&type=style&index=0&id=3995a3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995a3be",
  null
  
)

export default component.exports